
import React from 'react';
import { Loader2 } from 'lucide-react';

const LoadingView: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <main className="flex-1 container mx-auto p-3 md:p-6">
        <div className="flex justify-center items-center h-64">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <span className="ml-2">Loading business details...</span>
        </div>
      </main>
    </div>
  );
};

export default LoadingView;
